export const PIPELINE_STEPS = [
    {
        id: "channel",
        title: "0. Canal WhatsApp",
        short: "Evolution conectada",
        detail:
            "A sessão WhatsApp precisa estar open na Evolution. Use a seção Canal para ver status e QR.",
        uses: [],
        editable: true,
        tab: "channel",
    },
    {
        id: "inbound",
        title: "1. Mensagem chega",
        short: "WhatsApp → Evolution → Chatwoot",
        detail:
            "O cliente envia no WhatsApp. A Evolution só transporta; o Chatwoot registra a conversa (SoR).",
        uses: [],
        editable: false,
        tab: null,
    },
    {
        id: "ingress",
        title: "2. Ingress n8n",
        short: "Webhook Chatwoot Ingress",
        detail:
            "O n8n recebe message_created e decide se o bot responde ou se a conversa fica com humano.",
        uses: [],
        editable: false,
        tab: null,
    },
    {
        id: "kill",
        title: "3. Kill switch global",
        short: "Redis: bot ligado/desligado",
        detail:
            "Se as respostas automáticas estiverem desligadas, o ingress não executa o turno IA. A conversa vai para a equipe Triagem. O toggle em Operar grava a mesma flag.",
        uses: ["kill"],
        editable: true,
        tab: null,
    },
    {
        id: "debounce",
        title: "4. Debounce",
        short: "Agrupa rajadas de msgs",
        detail:
            "Várias mensagens rápidas do mesmo cliente são agrupadas antes do turno — evita respostas fragmentadas. Não é editável nesta tela.",
        uses: [],
        editable: false,
        tab: null,
    },
    {
        id: "rag",
        title: "5. RAG (Knowledge)",
        short: "Busca trechos da base",
        detail:
            "O ingress busca chunks relevantes na base salva em Config → Knowledge. O resultado vira CONTEXTO MANAFIX (dado, não instrução).",
        uses: ["knowledge"],
        editable: true,
        tab: "knowledge",
    },
    {
        id: "sections",
        title: "6. Monta o contexto",
        short: "Prompt + Guardrails + CONTEXTO",
        detail:
            "O modelo recebe seções delimitadas: INSTRUÇÕES (system prompt), GUARDRAILS (sempre), CONTEXTO MANAFIX (RAG). Guardrails têm prioridade sobre o pedido do usuário.",
        uses: ["system_prompt", "guardrails", "knowledge"],
        editable: true,
        tab: "system_prompt",
    },
    {
        id: "turno",
        title: "7. Turno IA nativo",
        short: "LLM no n8n",
        detail:
            "O turno IA nativo no Chatwoot Ingress chama o modelo (HTTP), aplica guardrails determinísticos e devolve reply ou handoff.",
        uses: ["system_prompt", "guardrails"],
        editable: false,
        tab: "system_prompt",
    },
    {
        id: "outbound",
        title: "8. Resposta ou handoff",
        short: "Agent Bot ou humano",
        detail:
            "Se o turno devolver reply, o Agent Bot publica no Chatwoot/WhatsApp. Se handoff, a conversa vai para a equipe certa com nota interna — regras nos Guardrails + Switchboard.",
        uses: ["guardrails"],
        editable: false,
        tab: "guardrails",
    },
];

export const USE_LABELS = {
    kill: "Kill switch",
    system_prompt: "System prompt",
    guardrails: "Guardrails",
    knowledge: "Knowledge",
};
